import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * Constants
 */
export const REQUEST = '@app/copmany/departments/get/REQUEST';
export const SUCCESS = '@app/copmany/departments/get/SUCCESS';
export const FAILURE = '@app/copmany/departments/get/FAILURE';
export const CLEAR = '@app/copmany/departments/get/CLEAR';

/**
 * Initial state
 */
const initState = {
    data: [],
    loading: false,
    error: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.error = '';
                draft.data = [];
                break;
            case SUCCESS:
                draft.data = payload.departments || [];
                draft.loading = false;
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = payload;
                break;
            case CLEAR:
                draft.data = [];
                draft.loading = false;
                draft.error = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.get(`/companies/show/${payload}`);
            yield put(actions.success(response.data.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
